import { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import useAuth from "../context/useAuth";
import { SkeletonStatCards } from "./Skeleton";

const AdminLayout = () => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  if (!user?.role)
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#f6f6f6",
          padding: "88px 24px 32px",
        }}
      >
        <SkeletonStatCards count={4} />
      </div>
    );
  if (!(Number(user.role) === 1 || Number(user.role) === 2))
    return <Navigate to="/" />;

  const isSuperAdmin = Number(user.role) === 1;

  return (
    <div>
      <Header
        showMenuToggle={isSuperAdmin}
        onMenuToggle={() => setSidebarOpen((prev) => !prev)}
      />
      {isSuperAdmin && (
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      )}
      <main className={`px-4 ${isSuperAdmin ? "admin-layout" : "user-layout"}`}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
